import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import { GET_VENDOR_DASHBOARD_REQUEST } from "./type";
import {
  getVendorDashboardSuccess,
  getVendorDashboardFailure,
} from "./action";
import { handleApiCallException } from "../../shared/action";
import { invokeApi } from "../../../helper/axiosHelper";

function* getVendorDashboard({ payload: data }) {
  try {
    const response = yield call(
      invokeApi,
      "post",
      "/vendorDashboard",
      data || {},
      {},
      "vendor"
    );
    if (response.status) {
      yield put(getVendorDashboardSuccess(response.data));
    } else {
      yield put(getVendorDashboardFailure());
      handleApiCallException(response.message);
    }
  } catch (error) {
    yield put(getVendorDashboardFailure());
    handleApiCallException(error);
  }
}

function* watchVendorDashboardRequest() {
  yield takeLatest(GET_VENDOR_DASHBOARD_REQUEST, getVendorDashboard);
}

function* VendorDashboardSaga() {
  yield all([fork(watchVendorDashboardRequest)]);
}

export default VendorDashboardSaga;
